module.exports = __webpack_public_path__ + "static/media/control-sales-logo.68aeddef.png";